import React from 'react'
import { ViewStyle, StyleSheet, Image, View, Text } from 'react-native'
import * as COLORS from 'constants/colors'
import * as FONTS from 'constants/fonts'

/**
 * Interface
 * @title : タイトル
 * @iconResource : アイコン表示
 * @styles : スタイル
 */
interface Props {
  title: string
  iconResource?: string
  style?: ViewStyle
}

/**
 * Styles
 */
const styles = StyleSheet.create({
  titleWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  title: {
    fontSize: FONTS.BODY.size,
    lineHeight: FONTS.BODY.leading,
    color: COLORS.ALERT,
    fontWeight: 'bold',
  },
  icon: {
    height: 24,
    width: 24,
    marginRight: 2,
  },
})

export function NotificationLabel(props: Props) {
  const { title, iconResource } = props

  return (
    <View style={[props.style, styles.titleWrapper]}>
      {iconResource && <Image style={styles.icon} source={{ uri: iconResource }} />}
      <Text style={styles.title}>{title}</Text>
    </View>
  )
}
